import React from 'react'

const SvgComponent = props => (
  <svg width="1em" height="1em" viewBox="0 0 18 4" {...props}>
    <title>{'More'}</title>
    <path
      d="M9 4a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm7 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4zM2 4a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"
      fill="#999"
      fillRule="nonzero"
    />
  </svg>
)

export default SvgComponent
